export default __webpack_public_path__ + "static/expedia-wotif-offer-35f00d8be8d3d6ce0026170319a0f3f6.webp";